export default __webpack_public_path__ + "static/media/delete.f9eba221.svg";